import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { VillageEditForm } from "@/features/village/VillageEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function VillageEdit() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/subdistrict",
            label: "Sub District (Kel/Desa)",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit Sub District (Kel/Desa)</H2>
      <VillageEditForm id={id} />
    </>
  );
}
